var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message-editor" }, [
    _c("div", { staticClass: "palette" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("wp.messageTypes")))]),
      _vm._v(" "),
      _c("div", { staticClass: "items" }, [
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.TEXT)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("text_fields")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.TEXT.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.RANDOM_TEXT
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("shuffle")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "chatbotv2." + _vm.Payloads.BOT_RESPONSE.RANDOM_TEXT.type
                  )
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.IMAGE)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("image")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.IMAGE.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.GALLERY)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("auto_awesome_motion")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.GALLERY.type)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(_vm.Payloads.BOT_RESPONSE.BUTTON)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("view_carousel")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("chatbotv2." + _vm.Payloads.BOT_RESPONSE.BUTTON.type)
                  )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.addResponseItem(
                  _vm.Payloads.BOT_RESPONSE.QUICK_REPLY
                )
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "icon material-icons",
                staticStyle: { "font-size": "30px" },
              },
              [_vm._v("smart_button")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "chatbotv2." + _vm.Payloads.BOT_RESPONSE.QUICK_REPLY.type
                  )
                )
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _c(
        "div",
        { staticClass: "payload-wrapper" },
        _vm._l(_vm.messages, function (p, i) {
          return _c(
            "div",
            { key: "payload-" + i + _vm.renderCount, staticClass: "payload" },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c(
                  "button",
                  {
                    staticClass: "toolbar-btn",
                    on: {
                      click: function ($event) {
                        return _vm.messages.splice(i, 1)
                      },
                    },
                  },
                  [
                    _c("md-icon", { staticStyle: { color: "#06a9f3" } }, [
                      _vm._v("delete"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "toolbar-btn" },
                  [
                    _c("md-icon", { staticStyle: { color: "#06a9f3" } }, [
                      _vm._v("swap_vert"),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              p.type === _vm.Payloads.BOT_RESPONSE.TEXT.type
                ? _c("TextMessage", {
                    attrs: {
                      "preview-mode": false,
                      "allowed-attributes": _vm.attributes,
                      "whatsapp-mode": true,
                    },
                    model: {
                      value: p.text,
                      callback: function ($$v) {
                        _vm.$set(p, "text", $$v)
                      },
                      expression: "p.text",
                    },
                  })
                : p.type === _vm.Payloads.BOT_RESPONSE.RANDOM_TEXT.type
                ? _c("RandomTextMessage", {
                    attrs: {
                      "show-attributes": true,
                      texts: p.texts,
                      "on-updated": function (data) {
                        return _vm.updateItem(p, data)
                      },
                      "on-attribute-added": _vm.$_.noop,
                      "whatsapp-mode": true,
                      "allowed-attributes": _vm.attributes,
                    },
                  })
                : p.type === _vm.Payloads.BOT_RESPONSE.GALLERY.type
                ? _c("GalleryMessageEditor", {
                    attrs: {
                      "show-attributes": true,
                      cards: p.cards,
                      "on-updated": function (data) {
                        return _vm.updateItem(p, data)
                      },
                      "on-attribute-added": _vm.$_.noop,
                      "flatted-diagram": {},
                      "whatsapp-mode": true,
                      "allowed-attributes": _vm.attributes,
                    },
                  })
                : p.type === _vm.Payloads.BOT_RESPONSE.IMAGE.type
                ? _c("ImageBotResponse", {
                    attrs: {
                      "default-image-url": p.imageUrl,
                      "default-asset-id": p.assetId,
                      "on-updated": function (data) {
                        return _vm.updateItem(p, data)
                      },
                      "whatsapp-mode": true,
                      "allowed-attributes": _vm.attributes,
                    },
                  })
                : p.type === _vm.Payloads.BOT_RESPONSE.FILE.type
                ? _c("FileBotResponse", {
                    attrs: {
                      "default-file-url": p.fileUrl,
                      "default-asset-id": p.assetId,
                      "on-updated": function (data) {
                        return _vm.updateItem(p, data)
                      },
                      "whatsapp-mode": true,
                      "allowed-attributes": _vm.attributes,
                    },
                  })
                : p.type === _vm.Payloads.BOT_RESPONSE.BUTTON.type
                ? _c("ButtonMessageEditor", {
                    attrs: {
                      flattedDiagram: [],
                      "whatsapp-mode": true,
                      "allowed-attributes": _vm.attributes,
                    },
                    model: {
                      value: _vm.messages[i],
                      callback: function ($$v) {
                        _vm.$set(_vm.messages, i, $$v)
                      },
                      expression: "messages[i]",
                    },
                  })
                : p.type === _vm.Payloads.BOT_RESPONSE.QUICK_REPLY.type
                ? _c("QuickReplyMessageEditor", {
                    attrs: {
                      flattedDiagram: [],
                      "whatsapp-mode": true,
                      "allowed-attributes": _vm.attributes,
                    },
                    model: {
                      value: _vm.messages[i],
                      callback: function ($$v) {
                        _vm.$set(_vm.messages, i, $$v)
                      },
                      expression: "messages[i]",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }